module.exports = __webpack_public_path__ + "img/backgroundVector.530eadbe.png";